import { Alert, DateRangePicker, FieldControl, Hint, Label } from '@americanexpress/dls-react';
import React from 'react';
import { DateRangeInputViewModel } from 'src/types/view-models/date-range-input.view.model';
import layout from 'src/styles/layout.module.scss';
import LiteralsService from 'src/services/literals/LiteralsService';
import { FieldHelperProps, FieldInputProps, FieldMetaProps, useField } from 'formik';
import Selectors from 'src/utils/selectors';

export default function DateRangeInput({
    id,
    datesIds,
    label,
    hint,
    className,
    hideLabel = false,
    dates,
    setDates
}: DateRangeInputViewModel): JSX.Element {
    const [, metaStart]: [FieldInputProps<string>, FieldMetaProps<string>, FieldHelperProps<string>] = useField(
        datesIds.start
    );
    const [, metaEnd]: [FieldInputProps<string>, FieldMetaProps<string>, FieldHelperProps<string>] = useField(
        datesIds.end
    );

    const status = {
        start: metaStart.touched && !!metaStart.error ? 'error' : 'default',
        end: metaEnd.touched && !!metaEnd.error ? 'error' : 'default'
    };

    const hasError: boolean = status.start === 'error' || status.end === 'error';

    const onDateChange = (e: any, date: { dateString: string }): void => {
        e.target.name === datesIds.start
            ? setDates((oldState: any) => ({
                  ...oldState,
                  start: date?.dateString
              }))
            : setDates((oldState: any) => ({
                  ...oldState,
                  end: date?.dateString
              }));
    };

    return (
        <FieldControl
            status={hasError ? 'error' : 'default'}
            data-cy={Selectors.SpendSmart.DATE_RANGE_INPUT}
            className={className}
        >
            {!hideLabel && label && <Label htmlFor={id}>{label}</Label>}
            <label htmlFor={datesIds.start} className={layout.screenReaderOnly}>
                {LiteralsService.getLiteral('DateRange.startDate')}
            </label>
            <label htmlFor={datesIds.end} className={layout.screenReaderOnly}>
                {LiteralsService.getLiteral('DateRange.endDate')}
            </label>
            {hint && <Hint htmlFor={id}>{hint}</Hint>}
            <DateRangePicker
                ids={datesIds}
                dates={dates}
                labels={LiteralsService.getLabels('DateRange.DateLabels')}
                onChange={onDateChange}
                status={status}
                errorMessage={metaStart.error || metaEnd.error}
            />
            {hasError && (
                <Alert id="dateRangeAlert" data-cy={Selectors.SpendSmart.DATE_RANGE_INPUT_ERROR}>
                    {metaStart.error || metaEnd.error}
                </Alert>
            )}
        </FieldControl>
    );
}
